
  import React from 'react';
  import { DICTIONARY } from "./non-components/dictionary";

  export default function Input(props) {
    const { dictionary = DICTIONARY, uploaded, onChange } = props;

    const renderInputRow = (name, label, description) => (
        <>
          <tr>
            <td><label htmlFor={name}>{label}</label></td>
            <td>
              <input
                  type="text"
                  name={name}
                  value={props[name]}
                  onChange={onChange}
                  disabled={!uploaded}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="2" className="input-desc">
              {`${dictionary[description].sv}`}
              <hr className="my-2" />
            </td>
          </tr>
        </>
    );

    return (
        <>
          <h3 className="h3">{`${dictionary.input_title.sv}`}</h3>
          <p>{`${dictionary.input_introduction.sv}`}</p>
          <hr className="my-2" />
          <form>
            <table>
              <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              {renderInputRow('organizationname_sv', 'OrganizationName', 'organizationname_sv_desc')}
              {renderInputRow('organizationname_en', 'OrganizationName', 'organizationname_en_desc')}
              {renderInputRow('organizationdisplayname_sv', 'OrganizationDisplayName', 'organizationdisplayname_sv_desc')}
              {renderInputRow('organizationdisplayname_en', 'OrganizationDisplayName', 'organizationdisplayname_en_desc')}
              {renderInputRow('organizationurl_sv', 'OrganizationURL', 'organizationurl_sv_desc')}
              {renderInputRow('organizationurl_en', 'OrganizationURL', 'organizationurl_en_desc')}
              {renderInputRow('scope', 'Scope', 'scope_desc')}
              </tbody>
            </table>
          </form>
        </>
    );
  }
